import {
  //
  GET_GOVERNANCE,
  GET_GOVERNANCE_SUCCESS,
  GET_GOVERNANCE_FAILURE,
  //
  SAVE_GOVERNANCE,
  SAVE_GOVERNANCE_SUCCESS,
  SAVE_GOVERNANCE_FAILURE,
  //
  LOAD_GOVERNANCE_VERSION,
  LOAD_GOVERNANCE_VERSION_SUCCESS,
  LOAD_GOVERNANCE_VERSION_FAILURE,
  //
  GET_RESIDENT_GOVERNANCE,
  GET_RESIDENT_GOVERNANCE_SUCCESS,
  GET_RESIDENT_GOVERNANCE_FAILURE,
  //
  UPDATE_GOVERNANCE_STATUS,
  UPDATE_GOVERNANCE_STATUS_SUCCESS,
  UPDATE_GOVERNANCE_STATUS_FAILURE,
  //
  COMPLETE_GOVERNANCE_ITEM,
  COMPLETE_GOVERNANCE_ITEM_SUCCESS,
  COMPLETE_GOVERNANCE_ITEM_FAILURE,
  //
  DISMISS_GOVERNANCE_ITEM,
  DISMISS_GOVERNANCE_ITEM_SUCCESS,
  DISMISS_GOVERNANCE_ITEM_FAILURE,
  //
  SNOOZE_GOVERNANCE_ITEM,
  SNOOZE_GOVERNANCE_ITEM_SUCCESS,
  SNOOZE_GOVERNANCE_ITEM_FAILURE,
} from "./constants";

// List
export const getGovernance = (payload, onSuccess) => ({
  type: GET_GOVERNANCE,
  payload,
  onSuccess,
});
export const getGovernanceSuccess = (payload) => ({
  type: GET_GOVERNANCE_SUCCESS,
  payload,
});
export const getGovernanceFailure = (payload) => ({
  type: GET_GOVERNANCE_FAILURE,
  payload,
});
// Save
export const saveGovernance = (payload, onSuccess) => ({
  type: SAVE_GOVERNANCE,
  payload,
  onSuccess,
});
// ADD
export const saveGovernanceSuccess = (payload) => ({
  type: SAVE_GOVERNANCE_SUCCESS,
  payload,
});
export const saveGovernanceFailure = (payload) => ({
  type: SAVE_GOVERNANCE_FAILURE,
  payload,
});
// Load Version
export const loadGovernanceVersion = (payload, onSuccess) => ({
  type: LOAD_GOVERNANCE_VERSION,
  payload,
  onSuccess,
});
export const loadGovernanceVersionSuccess = (payload) => ({
  type: LOAD_GOVERNANCE_VERSION_SUCCESS,
  payload,
});
export const loadGovernanceVersionFailure = (payload) => ({
  type: LOAD_GOVERNANCE_VERSION_FAILURE,
  payload,
});

// Get Resident Governance
export const getResidentGovernance = (payload, onSuccess) => ({
  type: GET_RESIDENT_GOVERNANCE,
  payload,
  onSuccess,
});
export const getResidentGovernanceSuccess = (payload) => ({
  type: GET_RESIDENT_GOVERNANCE_SUCCESS,
  payload,
});
export const getResidentGovernanceFailure = (payload) => ({
  type: GET_RESIDENT_GOVERNANCE_FAILURE,
  payload,
});

// Update Governance Status
export const updateGovernanceStatus = (payload, onSuccess) => ({
  type: UPDATE_GOVERNANCE_STATUS,
  payload,
  onSuccess,
});
export const updateGovernanceStatusSuccess = (payload) => ({
  type: UPDATE_GOVERNANCE_STATUS_SUCCESS,
  payload,
});
export const updateGovernanceStatusFailure = (payload) => ({
  type: UPDATE_GOVERNANCE_STATUS_FAILURE,
  payload,
});

// Complete Governance Item
export const completeGovernanceItem = (payload, onSuccess) => ({
  type: COMPLETE_GOVERNANCE_ITEM,
  payload,
  onSuccess,
});
export const completeGovernanceItemSuccess = (payload) => ({
  type: COMPLETE_GOVERNANCE_ITEM_SUCCESS,
  payload,
});
export const completeGovernanceItemFailure = (payload) => ({
  type: COMPLETE_GOVERNANCE_ITEM_FAILURE,
  payload,
});

// Dismiss Governance Item — payload: { residentId, itemId, formData }
export const dismissGovernanceItem = (payload, onSuccess) => ({
  type: DISMISS_GOVERNANCE_ITEM,
  payload,
  onSuccess,
});
export const dismissGovernanceItemSuccess = (payload) => ({
  type: DISMISS_GOVERNANCE_ITEM_SUCCESS,
  payload,
});
export const dismissGovernanceItemFailure = (payload) => ({
  type: DISMISS_GOVERNANCE_ITEM_FAILURE,
  payload,
});

// Snooze ("Check later") Governance Item — payload: { residentId, itemId, formData }
export const snoozeGovernanceItem = (payload, onSuccess) => ({
  type: SNOOZE_GOVERNANCE_ITEM,
  payload,
  onSuccess,
});
export const snoozeGovernanceItemSuccess = (payload) => ({
  type: SNOOZE_GOVERNANCE_ITEM_SUCCESS,
  payload,
});
export const snoozeGovernanceItemFailure = (payload) => ({
  type: SNOOZE_GOVERNANCE_ITEM_FAILURE,
  payload,
});
